<div mat-dialog-title fxLayoutAlign="space-between center">
    <div class="forge-typography--heading4">Notes</div>

    <div>
        <forge-icon-button *ngIf="canAdd" (click)="addNote()">
            <forge-tooltip placement="bottom">Add note</forge-tooltip>
            <forge-icon name="add"></forge-icon>
        </forge-icon-button>
    </div>
</div>

<mat-dialog-content [formGroup]="formGroup" class="note-container">
    <ng-container *ngIf="isLoaded; else loading">
        <ng-container *ngIf="isSingleNote; then singleNote; else noteList">
        </ng-container>
    </ng-container>

    <busy-indicator *ngIf="isProcessing" [page]="true"></busy-indicator>
</mat-dialog-content>

<mat-dialog-actions class="form-actions" align="end">
    <command-bar [commands]="commands"></command-bar>
</mat-dialog-actions>

<ng-template #loading>
    <busy-indicator [big]="true">
    </busy-indicator>
</ng-template>

<ng-template #noteList>
    <notes [hideSubject]="hideSubject" [model]="notes" [viewOnly]="viewOnly" (delete)="onDelete($event)">
    </notes>
</ng-template>

<ng-template #singleNote>
    <single-note [model]="note" [viewOnly]="viewOnly">
    </single-note>
</ng-template>
